import { rgba } from "polished";

import { CenterContent, CenteredText, Icon } from "shared/styles";
import { SubscriptionSummary } from "Bands/pages/subscription/containers";
import { copy } from "shared/assets";
import { Spacer } from "shared/layout";
import { Button, Title } from "shared/components";
import { getStatus } from "shared/styles/defaults";
import { IStatus } from "shared/types";
import { BAND_PATHS } from "Bands/router";
import { useCompanyRoute } from "Bands/utils";
import { useSubscriptionContext } from "Bands/contexts";
import { FourOhFour } from "shared/pages";
import { Clock } from "shared/assets/icons";
import { colors } from "shared/styles/constants";

const pendingCopy = copy.subscription.pending;

export const SubscriptionPending = () => {
  const { selectedSubscription, selectedBilling } = useSubscriptionContext();

  const { iconColor } = getStatus(IStatus.warning);
  const { pushRoute: pushCompanyRoute } = useCompanyRoute();

  if (!selectedSubscription || !selectedBilling) {
    return <FourOhFour />;
  }

  return (
    <CenterContent>
      <Spacer size="xl" align="center">
        <Icon
          isCircle
          as={Clock}
          height="60px"
          width="60px"
          color={iconColor}
          padding="18px"
          backgroundColor={rgba(iconColor as string, 0.25) as colors}
        />
        <Title asComponent="h2">{pendingCopy.title}</Title>
        <CenteredText
          dangerouslySetInnerHTML={{ __html: pendingCopy.subtitle }}
        />
        <SubscriptionSummary />
        <Button
          onClick={() =>
            pushCompanyRoute(BAND_PATHS.COMPANY_DASHBOARD, {
              companyId: selectedBilling?.id,
            })
          }
        >
          {pendingCopy.button}
        </Button>
      </Spacer>
    </CenterContent>
  );
};
